export default __webpack_public_path__ + "static/media/kn.48e20394.svg";